import { Dispatch } from 'react';
import { RatePlanPatchRequest, RatePlanRequest } from '../../../api/pricing/pricing.types';
import { PricingApi } from '../../../api/api.apiclient';
import {
  DELETE_RATE_PLAN,
  DeleteRatePlanAction,
  GET_RATE_PLAN,
  GET_RATE_PLAN_LIST,
  PATCH_RATE_PLAN_STATUS,
  POST_RATE_PLAN,
  PUT_RATE_PLAN,
  SAVE_DESK_GROUP_ID,
  SAVE_PRODUCT_ID,
  SaveDeskGroupIdAction,
  SaveProductIdAction,
  STORE_ACRISS_CODES,
  STORE_BROKER_RATE_ID,
  STORE_DESK_CODE,
  STORE_DESK_GROUP_ID,
  STORE_PRODUCT_ID,
  STORE_STARTING_DATE,
  StoreBrokerRateCodeAction,
  StoreDeskCodeAction,
  StoreDeskGroupIdAction,
  StoreProductIdAction,
  StoreStartingDateAction
} from '../types/rateplan.types';
import { STORED_ACRISS_CODES, STORED_DESK_GROUP_ID, STORED_PRODUCT_ID } from '../../../types/app.index';
import { GET_CAR_MODELS_LIST } from '../../setup/types/carmodel.types';
import { GET_DESK_GROUP_LIST } from '../../setup/types/deskgroup.types';
import { GET_PRODUCT_LIST } from '../../setup/types/product.types';
import { GET_RATE_PLAN_PERIODS } from '../../core/types/rateplanperiod.types';

export const getRatePlanList = (productId?: number, deskGroupId?: number, carClasses?: string[]) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.RatePlan.listAllRatePlans(productId, deskGroupId, carClasses);

  dispatch({
    type: GET_RATE_PLAN_LIST,
    payload: {
      page: response.data
    }
  });
};

export const getRatePlan = (id: number) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await PricingApi.RatePlan.getOneRatePlan(id);

    dispatch({
      type: GET_RATE_PLAN,
      payload: {
        selectedRatePlan: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_RATE_PLAN,
      payload: {
        selectedRatePlan: null
      }
    });
  }
};

export const editRatePlan = (id: number, request: RatePlanRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.RatePlan.editRatePlan(id, request);

  dispatch({
    type: PUT_RATE_PLAN,
    payload: {
      selectedRatePlan: response.data
    }
  });
};

export const addNewRatePlan = (request: RatePlanRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.RatePlan.addnewRatePlan(request);

  dispatch({
    type: POST_RATE_PLAN,
    payload: {
      success: true
    }
  });
};

export const patchRatePlan = (id: number, request: RatePlanPatchRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.RatePlan.patchRatePlan(id, request);

  dispatch({
    type: PATCH_RATE_PLAN_STATUS,
    payload: {
      selectedRatePlan: response.data
    }
  });
};


export const deleteRatePlan = (id: number) => async (dispatch: Dispatch<DeleteRatePlanAction>) => {
  await PricingApi.RatePlan.deleteRatePlan(id);
  dispatch({
    type: DELETE_RATE_PLAN,
    payload: {
      success: true
    }
  });
};

export const storeProductId = (id: number) => async (dispatch: Dispatch<StoreProductIdAction>) => {
  dispatch({
    type: STORE_PRODUCT_ID,
    payload: {
      productId: id
    }
  });
};

export const storeDeskGroupId = (id: number) => async (dispatch: Dispatch<StoreDeskGroupIdAction>) => {
  dispatch({
    type: STORE_DESK_GROUP_ID,
    payload: {
      deskGroupId: id
    }
  });
};

export const saveProductId = (id: number) => async (dispatch: Dispatch<SaveProductIdAction>) => {
  localStorage.setItem(STORED_PRODUCT_ID, JSON.stringify(id));
  dispatch({
    type: SAVE_PRODUCT_ID,
    payload: {
      productId: id
    }
  });
};

export const saveDeskGroupId = (id: number) => async (dispatch: Dispatch<SaveDeskGroupIdAction>) => {
  localStorage.setItem(STORED_DESK_GROUP_ID, JSON.stringify(id));
  dispatch({
    type: SAVE_DESK_GROUP_ID,
    payload: {
      deskGroupId: id
    }
  });
};

export const saveAcrissCodes = (acrissCodes: string[]) => async (dispatch: Dispatch<any>) => {
  localStorage.setItem(STORED_ACRISS_CODES, JSON.stringify(acrissCodes));
  dispatch({
    type: STORE_ACRISS_CODES,
    payload: {
      acrissCodes: acrissCodes
    }
  });
};

export const storeDeskCode = (code: string) => async (dispatch: Dispatch<StoreDeskCodeAction>) => {
  dispatch({
    type: STORE_DESK_CODE,
    payload: {
      deskCode: code
    }
  });
};

export const storeBrokerRateCode = (code: string) => async (dispatch: Dispatch<StoreBrokerRateCodeAction>) => {
  dispatch({
    type: STORE_BROKER_RATE_ID,
    payload: {
      brokerRateCode: code
    }
  });
};

export const storeStartingDate = (date: string) => async (dispatch: Dispatch<StoreStartingDateAction>) => {
  dispatch({
    type: STORE_STARTING_DATE,
    payload: {
      startingDate: date
    }
  });
};

export const getRatePlansView = (coreProductId?: number) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.RatePlan.getRatePlanViewContent(coreProductId);

  dispatch({
    type: GET_CAR_MODELS_LIST,
    payload: {
      page: response.data.carModels
    }
  });

  dispatch({
    type: GET_DESK_GROUP_LIST,
    payload: {
      page: response.data.deskGroups
    }
  });

  dispatch({
    type: GET_PRODUCT_LIST,
    payload: {
      page: response.data.products
    }
  });

  dispatch({
    type: GET_RATE_PLAN_PERIODS,
    payload: {
      page: response.data.ratePlanPeriods
    }
  });

  dispatch({
    type: GET_RATE_PLAN_LIST,
    payload: {
      page: response.data.ratePlans
    }
  });

  if (response.data.selectedRatePlan) {
    dispatch({
      type: GET_RATE_PLAN,
      payload: {
        selectedRatePlan: response.data.selectedRatePlan
      }
    });
  }

};
